export default __webpack_public_path__ + "static/media/open-graph-4fd21aa09f.c0abd756.png";